import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
let SubmitPreview = class SubmitPreview extends Vue {
  get totalScore() {
    return QuestionnaireEditModule.totalScore;
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  get submitData() {
    return QuestionnaireEditModule.submitData;
  }
};
SubmitPreview = __decorate([Component({
  name: "submitPreview"
})], SubmitPreview);
export default SubmitPreview;